// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OnboardingPopover__container-dcd361 {
  padding: 0;
  border-radius: 12px;
  background-color: transparent;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/OnboardingPopover/OnboardingPopover.styles.m.css"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;AACF","sourcesContent":[".container {\n  padding: 0;\n  border-radius: 12px;\n  background-color: transparent;\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OnboardingPopover__container-dcd361`
};
module.exports = ___CSS_LOADER_EXPORT___;
